jQuery(document).ready(function ($) {
  /*------------------------------------------------------*/
  /*------------------------------------------------------*/
  //Toggle menu
  jQuery(".mega-menu-toggle").click(function () {
    jQuery(".menu-backg").toggleClass("fullHeight");
    jQuery(".menu-Wrap").toggleClass("fullHeight");
    jQuery(".search-icon-sub").toggleClass("hideMe");
    jQuery(".searchengine").removeClass("showMe");
    jQuery(".search-bar-sub").removeClass("showMe");
    jQuery(".mob-menu-open").toggleClass("col-xs-12");
    jQuery(
      "#mega-menu-wrap-primary .mega-menu-toggle .mega-toggle-block-right"
    ).toggleClass("open");
  });

  //jQuery("#nav-icon").click(function() {
  //   jQuery('#nav-icon').toggleClass('open');
  //   jQuery('#site__overlay').toggleClass('showMe');
  //   jQuery('.menu-Wrap nav ul').toggleClass('showMe');
  // });

  // Bind Enter key to click this
  $(".sidebar-title").keyup(function (e) {
    if (e.keyCode == 13) {
      $(this).click();
    }
  });

  const navbarCollapse = $(".js-collapse");
  const closeMenu = $(".js-close-menu");
  const navbarToggler = $(".js-navbar-toggler");
  const header = $("header");
  let oldScrollY = window.scrollY;

  function scrollFunction() {
    if (window.scrollY > 80) {
      if (oldScrollY < window.scrollY) {
        header.addClass("headerScrolled");
      } else {
        header.removeClass("headerScrolled");
      }
    }
    oldScrollY = window.scrollY;
  }

  $(window).on("scroll", function () {
    scrollFunction();
  });

  const openMenuFunc = () => {
    $(".body-overlay").fadeIn(100);
    $("body").addClass("no-scroll");
    if (navbarCollapse.hasClass("closeMenu")) {
      navbarCollapse.removeClass("closeMenu").addClass("showMenu");
    } else {
      navbarCollapse.addClass("showMenu");
    }
  };

  $(document).mouseup(function (e) {
    if (
      !navbarCollapse.is(e.target) && // if the target of the click isn't this block...
      navbarCollapse.has(e.target).length === 0
    ) {
      // ... nor a descendant of this block
      $(".body-overlay").fadeOut(100);
      $("body").removeClass("no-scroll");
      navbarCollapse.removeClass("showMenu").addClass("closeMenu");
    }
  });

  const closeMenuFunc = () => {
    $(".body-overlay").fadeOut(100);
    $("body").removeClass("no-scroll");
    if (navbarCollapse.hasClass("showMenu")) {
      navbarCollapse.removeClass("showMenu").addClass("closeMenu");
    } else {
      navbarCollapse.addClass("closeMenu");
    }
  };

  navbarToggler.on("click", openMenuFunc);
  closeMenu.on("click", closeMenuFunc);

  $(".search-button").click(function () {
    $(".right-block__search form").toggleClass("form-open");
    $(".right-block__search .form-open input").focus();
  });

  const stickyModal = $(".js-sticky-block");

  if (stickyModal.length > 0) {
    const stickyTriggerButton = stickyModal.find(".js-trigger-button");
    const stickyContent = stickyModal.find(".js-sticky-content");

    // Close the floating ring us modal
    const closestickyModal = () => {
      if (stickyContent.attr("aria-expanded") == "false") {
        return $(document).off("click", closestickyModal);
      }

      stickyContent.attr("aria-expanded", "false");
      stickyContent.slideUp(300);
      setTimeout(() => stickyTriggerButton.slideDown(300), 300);
      $(document).off("click", closestickyModal);
    };

    // Activate the modal
    stickyTriggerButton.on("click", (event) => {
      event.stopPropagation();
      if (stickyContent.attr("aria-expanded") == "true") return;
      stickyContent.attr("aria-expanded", "true");
      stickyTriggerButton.slideUp(300);
      setTimeout(() => stickyContent.slideDown(300), 300);
      $(document).on("click", closestickyModal);
    });

    stickyModal.on("click", (event) => {
      event.stopPropagation();
    });
  }
});

/*------------------------------------------------------*/
